export default __webpack_public_path__ + "static/ppq-modal-images-340a4efb0d12d3e412c5bbcfd99f0454.png";